import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { EnvironmentService } from '../../../../../../common/services/env-configuration/environment.service';

@Component({
  selector: 'app-form-field-file-upload',
  templateUrl: './file-upload-form-field.component.html',
  styleUrls: ['./file-upload-form-field.component.scss'],
  standalone: false,
})
export class FileUploadFormFieldComponent extends DataTypeComponent implements OnDestroy, AfterViewInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @ViewChild('fileInput') file;

  public files: Set<File> = new Set();

  rowData: any;

  filename: string;

  dragging = false;

  loaded = false;

  loadedFile = false;

  uploading = false;

  activeColor = 'green';

  baseColor = '#ccc';

  overlayColor = 'red';

  fileSuffix = '*.csv';

  constructor(
    private environmentService: EnvironmentService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit() {
    if (this.data !== undefined) {
      this.filename = this.data;
      this.changeDetectorRef.detectChanges();
      if (this.fieldConfig.suffix !== undefined) {
        this.fileSuffix = this.fieldConfig.suffix;
      }
    }
  }

  setRowData(entity: any) {
    this.rowData = entity;
  }

  ngOnDestroy() {}

  handleDragEnter() {
    this.dragging = true;
    this.changeDetectorRef.detectChanges();
  }

  handleDragLeave() {
    this.dragging = false;
    this.changeDetectorRef.detectChanges();
  }

  handleDrop(e) {
    e.preventDefault();
    this.dragging = false;
    this.handleInputChange(e);
    this.changeDetectorRef.detectChanges();
  }

  onFilesAdded() {
    const newFiles: Set<File> = new Set();

    // re-set list as I only want 1 file
    const { files } = this.file.nativeElement;
    for (const key in files) {
      if (!isNaN(parseInt(key))) {
        newFiles.add(files[key]);
      }
    }
    this.addFile(newFiles);
  }

  addFile(files: Set<File>) {
    if (files.size > 0) {
      // re-set list as I only want 1 file
      this.files = new Set();

      files.forEach((f) => {
        this.files.add(f);
      });
      this.data = this.files;
      this.loadedFile = true;
      this.changeDetectorRef.detectChanges();
      this.formGroup.get(this.fieldConfig.name).setValue(this.data, { emitEvent: false });
    }
  }

  handleInputChange(e) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    const files: Set<File> = new Set();
    files.add(file);
    this.addFile(files);
  }
}
